var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.516 14.67s-.5.502-.5 1.33M9.5 11h.01m5.99 0h.01m2.037-2.192s-.458-.077-.858-.478c-.4-.4-.53-.767-.53-.767M15.016 16c0 .828.5 1.345.5 1.345m-.5-1.345H10.01m-.5-1.33s.5.502.5 1.33m0 0c0 .828-.5 1.345-.5 1.345M7.62 8.808s.457-.077.858-.478c.4-.4.53-.767.53-.767M21.5 12a9 9 0 11-18 0 9 9 0 0118 0z",
    stroke: "#7BAB52",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgSick;